const gtm = require('google-tag-manager');

function pushConversionChuteEvent (event, data = {}) {
	if (event) {
		gtm.pusher()
			.event(event)
			.extend(data)
			.push();
	}
}

module.exports = pushConversionChuteEvent;
